import React, { useState, useEffect, useRef } from 'react';
import { Checkbox } from "primereact/checkbox";
import { Button, CheckboxField } from "../../helpers";
import { Table } from "../../helpers"
import { Link } from "react-router-dom";
import moment from "moment"

import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import { Sidebar } from 'primereact/sidebar';
import { Tooltip } from "primereact/tooltip";

import ButtonGroup from '../../common/ButtonGroup';

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import UnreadMessageImg from '../../images/unread-message.webp'
import NewTicketIcon from '../../images/new_icon.jpeg'
import { searchTickets } from '../../services/api/tickets';
import { fetchTicketList, updateSearchParams, setInitialLoad, setIsSearchVisible } from "../../services/redux/reducers/tickets/tickets";
import { TicketSearch } from './components/TicketSearch'

import { fetchTicketStatus, fetchTicketCategory, fetchTicketSubCategory } from '../../services/redux/reducers/commonThunk';

import { DATE_TIME_FORMAT, DATE_FORMAT } from '../../constants'
import useTranslationWithLoading from '../../common/hooks/useTranslationWIthLoading';
import { getFullName, isMobile, sortArrayOfObjectsInAscendingDateOrder } from '../../utils';
import { useSearchPin } from '../../hooks/useSearchPin';

import SmartFilterActiveImg from "../../images/smartFilterActiveImg_.png"


export const TicketList = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { isSearchPinned, toggleSearchPin, setSearchPin } = useSearchPin()

    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)

    let ticketList = useSelector(state => state.ticketsData.ticketList)
    const userId = useSelector(state => state.userDetails).userId
    const isLoading = useSelector(state => state.ticketsData.loading)
    const paginationParams = useSelector(state => state.ticketsData.paginationParams)
    const searchParams = useSelector(state => state.ticketsData?.searchParams)
    const isInitialLoad = useSelector(state => state.ticketsData.isInitialLoad)
    const isSearchVisible = useSelector(state => state.ticketsData.isSearchVisible)
    const isSearchActive = useSelector(state => state.ticketsData.isSearchActive)

    const ticketCategories = useSelector(state => state.common.ticketCategories)
    const ticketSubCategories = useSelector(state => state.common.ticketSubCategories)
    const ticketStatus = useSelector(state => state.common.ticketStatus)

    const userDetails = useSelector(state => state.userDetails)
    const activeUserRoleDetails = useSelector((state) => state.userDetails?.activeUserRoleDetails)
    const PMCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)

    const isMobileDevice = isMobile()
    const [dummyState, setDummyState] = useState(0)

    const getStarredTicketIds = () => {
        return JSON.parse(localStorage.getItem('starredTickets') || '[]')
    }

    const [starredTicketIds, setStarredTicketIds] = useState(getStarredTicketIds())

    useEffect(() => {
        dispatch(fetchTicketStatus())
        dispatch(fetchTicketCategory())
        dispatch(fetchTicketSubCategory())
        //getIntialLoadData()

        const handleStorageChange = (event) => {
            if (event.key && event.key.startsWith('ticket_') && event.key.endsWith('_last_viewed')) {
                setDummyState(Date.now())
            }
            if (event.key === 'starredTickets') {
                setStarredTicketIds(getStarredTicketIds())
            }
        }

        window.addEventListener('storage', handleStorageChange)
        return () => {
            window.removeEventListener('storage', handleStorageChange)
        }
    }, [])

    useEffect(() => {
        if(ticketCategories.length && ticketSubCategories.length){
            getIntialLoadData()
        }
    }, [ticketCategories, ticketSubCategories])

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
          }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])

    const getIntialLoadData = () => {
        if (isInitialLoad) {
            dispatch(setInitialLoad(false))

            const assignToMe = true
            const openStatus = true

            const currentDate = new Date()
            let fromDate = currentDate.setMonth(currentDate.getMonth() - 1)
            fromDate = new Date(fromDate)
            let toDate = new Date()
            const procmartUser = activeUserRoleDetails?.companyId === PMCompanyDetails.companyId

            const updatedSearchParams = {
                ...searchParams,
                fromDate,
                toDate,
                assignToMe,
                openStatus,
                procmartUser,
                smartSearch: true
            }

            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(fetchTicketList({
                ...paginationParams,
                ...updatedSearchParams,
                userId
            }))
        }
    }

    const getDueDate = (row) => {

        if (row.dueDate) {

            const todayDate = moment(new Date())
            let dueDate = moment(new Date(row.dueDate))
            const dateDiff = dueDate.diff(todayDate, 'days')

            let textColor = ''
            if (dateDiff == 0) {
                let duration = moment.duration(dueDate.diff(todayDate))
                let hoursDiffrence = duration.asHours()

                if (hoursDiffrence > 0) {
                    textColor = '#45a6ad' //lightgreen
                } else {
                    textColor = 'rgb(160, 160, 63)' //yellow
                }
            }
            if (dateDiff) {
                if (dateDiff < 0) {
                    textColor = '#cf2634' //red
                }
                if (dateDiff > 0 && dateDiff < 3) {
                    textColor = '#45a6ad' //lightgreen
                }
                if (dateDiff >= 3) {
                    textColor = '#045050' //darkgreen
                }
            }

            return <div><span style={{ color: textColor, fontWeight: 'bold' }} > {moment(new Date(row?.dueDate)).format(DATE_FORMAT)}</span></div>
        }
        else {
            return <div> - </div>
        }

    }

    const getLastViewedTime = (ticketId) => {
        return localStorage.getItem(`ticket_${ticketId}_last_viewed`)
    }

    const getTicketTitle = (rowData) => {
        const lastViewedTimeStr = getLastViewedTime(rowData.ticketId)
        const lastViewedTime = lastViewedTimeStr ? new Date(lastViewedTimeStr) : null

        const latestComment = rowData.ticketComments.length > 0 ? sortArrayOfObjectsInAscendingDateOrder(rowData.ticketComments, "createdAt", "DESC")[0] : null

        let showNewTicketIcon = false
        let showUnreadCommentIcon = false

        if (rowData.ticketComments.length === 0 && rowData.createdBy !== userDetails.userId) {
            if (!lastViewedTime || new Date(rowData.updatedAt) > lastViewedTime) {
                showNewTicketIcon = true
            }
        }
        else if (rowData.ticketComments.length > 0) {
            if (latestComment.createdBy !== userDetails.userId) {
                if (!lastViewedTime || new Date(latestComment.createdAt) > lastViewedTime) {
                    showUnreadCommentIcon = true
                }
            }
        }

        return (
            <div>
                <Link
                    to={`./edit/${rowData.ticketId}`}
                    style={{
                        color: showNewTicketIcon ? 'black' : showUnreadCommentIcon ? 'black' : '#3366cc',
                        fontWeight: showNewTicketIcon ? 'bold' : 'normal'
                    }}
                >
                    <div>
                        <p className='m-0 p-0' style={{ wordBreak: 'break-word', display: 'flex', justifyContent: 'center' }}>
                            {showNewTicketIcon && <span className="notification-dot mr-1"></span>}
                            {rowData.title}
                            {showUnreadCommentIcon && (
                                <img 
                                    src={UnreadMessageImg} 
                                    className={`tooltip-unread-${rowData.ticketId}`} 
                                    style={{ height: 12}} 
                                />
                            )}
                        </p>
                    </div>

                    {showUnreadCommentIcon && (
                        <Tooltip target={`.tooltip-unread-${rowData.ticketId}`} position="top" autoHide>
                            Unread comments
                        </Tooltip>
                    )}
                    {showNewTicketIcon && (
                        <Tooltip target={`.tooltip-new-${rowData.ticketId}`} position="top" autoHide>
                            New ticket
                        </Tooltip>
                    )}
                </Link>
            </div>
        )
    }

    const getPriority = (row) => {
        let priority = row.priority
        let priorityColor = ''
        switch (priority) {
            case 'URGENT':
                priorityColor = '#ff00008c'
                break
            case 'HIGH':
                priorityColor = '#ffa500b0'
                break
            case 'MEDIUM':
                priorityColor = '#0000ff6e'
                break
            case 'LOW':
                priorityColor = '#00800099'
                break
            default:
                priorityColor = 'black'
        }

        return (
            <div className='ticket-priority' style={{ backgroundColor: priorityColor }}>{row.priority}</div>
        )
    }

    const handleSmartFilter = async () => {
        let updatedSerachParams = {
            ...paginationParams,
            ...searchParams,
            userId,
            smartSearch: true,
        }
        dispatch(fetchTicketList(updatedSerachParams))
        dispatch(updateSearchParams({ ...searchParams, smartSearch: true }))
    }

    const smartFilterBody = () => {
        return (
            <img src={SmartFilterActiveImg} style={{ width: "25px", cursor: 'pointer', backgroundImage: 'radial-gradient(circle at top left, #cad4ff 2%, #ffffff00)' }} onClick={() => handleSmartFilter()} />
        )
    }

    const getTicketIdBody = (row) => {
        return <div> {row.ticketId}</div>
    }

    const getCreatedAtBody = (row) => {
        const relatedCreatedByUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === row.createdBy)
        return (
            <div>
                {getFullName(relatedCreatedByUser?.firstName, relatedCreatedByUser?.lastName)}<br />
                {row.createdAt ? <span style={{ fontSize: '12px', color: 'gray' }}> {moment(new Date(row.createdAt)).format(DATE_TIME_FORMAT)} </span> : "-"}
            </div>
        )
    }

    const getLastUpdatedAtBody = (row) => {
        if (row.ticketComments.length) {
            const sortedComments = sortArrayOfObjectsInAscendingDateOrder(row.ticketComments, "createdAt", "DESC")
            const latestComment = sortedComments[0]
            const latestCommentCreator = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === latestComment.createdBy)
            const lastUpdatedAt = latestComment.createdAt
            return (
                <div>
                    {latestCommentCreator ? getFullName(latestCommentCreator.firstName, latestCommentCreator.lastName) : "-"}<br />
                    {lastUpdatedAt ? (
                        <span style={{ fontSize: '12px', color: 'gray' }}>
                            {moment(new Date(lastUpdatedAt)).format(DATE_TIME_FORMAT)}
                        </span>
                    ) : "-"}
                </div>
            )
        }
        return <div> - </div>
    }

    const getAssignedToBody = (row) => {
        const relatedAssigneeUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === row.assignedTo)
        if (relatedAssigneeUser) {
            return <div>{getFullName(relatedAssigneeUser.firstName, relatedAssigneeUser.lastName)}</div>
        }
        return <div> - </div>
    }

    const getTicketCategoryBody = (row) => {
        const relatedCategory = ticketCategories.find(eachCategory => eachCategory.ticketCategoryId === row.categoryId)
        const relatedSubCategory = ticketSubCategories.find(eachSubCategory => eachSubCategory.ticketSubcategoryId === row.subcategoryId)

        return (
            <div>
                {relatedCategory.categoryName}
                <br />
                <span style={{ fontSize: '12px', color: 'gray' }}>
                    ({relatedSubCategory.subcategoryName})
                </span>
            </div>
        )
    }

    const getTicketStatusBody = (row) => {
        const relatedStatus = ticketStatus.find(eachStatus => eachStatus.ticketStatusId === row.ticketStatusId)
        return (
            <div>{relatedStatus.statusName}</div>
        )
    }

    const toggleStarredTicket = (ticketId) => {
        let starredTicketIds = getStarredTicketIds()
        if (starredTicketIds.includes(ticketId)) {
            starredTicketIds = starredTicketIds.filter(eachStarredTicketId => eachStarredTicketId !== ticketId)
        } else {
            starredTicketIds.push(ticketId)
        }
        localStorage.setItem('starredTickets', JSON.stringify(starredTicketIds))
        window.dispatchEvent(new Event('storage'))
    }

    const getStarredColumnBody = (rowData) => {
        const isTicketStarred = starredTicketIds.includes(rowData.ticketId)

        return (
            <i
                className={`pi ${isTicketStarred ? 'pi-star-fill text-yellow-500' : 'pi-star'}`}
                style={{ fontSize: '1rem', cursor: 'pointer' }}
                onClick={() => {
                    toggleStarredTicket(rowData.ticketId)
                    setStarredTicketIds(getStarredTicketIds())
                }}
            />
        )
    }

    const tableColumns = [
        {
            header: smartFilterBody,
            body: getStarredColumnBody,
            style: { minWidth: "5px" }
        },
        {
            header: 'Ticket Id',
            body: getTicketIdBody,
            style: { minWidth: "120px" }
        },
        {
            header: 'Title',
            field: 'title',
            body: getTicketTitle,
            style: { minWidth: "450px" }
        },
        {
            header: 'Created By',
            field: 'createdBy',
            body: getCreatedAtBody,
            style: { minWidth: "150px" }
        },
        {
            header: 'Last Updated By',
            field: 'createdBy',
            body: getLastUpdatedAtBody,
            style: { minWidth: "150px" }
        },
        {
            header: 'Due Date',
            field: 'dueDate',
            body: getDueDate,
            style: { minWidth: "100px" }
        },
        {
            header: 'Priority',
            field: 'priority',
            body: getPriority,
            style: { minWidth: "100px" }
        },
        {
            header: 'Assigned To',
            field: 'assignedUser.firstName',
            body: getAssignedToBody,
            style: { minWidth: "150px" }
        },
        {
            header: 'Category',
            field: 'category.categoryName',
            body: getTicketCategoryBody,
            style: { minWidth: "150px" }
        },
        {
            header: 'Status',
            field: getTicketStatusBody,
        }
    ]

    const handlePageChange = async (e) => {
        let paginatorParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            userId: userId,
            ...searchParams
        }
        if (searchParams.searchBy && searchParams.searchBy !== "all") {
            paginatorParams[searchParams.searchBy] = searchParams.searchText.trim();
        }
        dispatch(fetchTicketList(paginatorParams))
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
        // if (!isSearchPinned) {
        //   dispatch(setIsSearchVisible(!isSearchVisible))
        // }
    }

    const actionButtons = [
        {
            label: "Create Ticket",
            command: () => navigate(`/tickets/add`)
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]

    let displaySearchBox = isSearchPinned || isHoveringSearchZone || isSearchVisible
    return (

        <div className="piwise-invoce-booking-layout flex flex-column">
            <Toast ref={Toast} />
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">{activeUserRoleDetails?.companyId === PMCompanyDetails.companyId ? 'DRISHTI' : 'TICKET'}</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="pi-wise-invoice-booking-table" style={{ order: "1", width: displaySearchBox && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1">
                            <Table
                                lazy
                                page={paginationParams.pageNo - 1}
                                onPageChange={(e) => handlePageChange(e)}
                                tableColumns={tableColumns}
                                data={ticketList}
                                rows={paginationParams.recordsPerPage}
                                scrollable={true}
                                scrollHeight={"550px"}
                                paginator
                                totalRecords={paginationParams.totalRecords}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>

                {displaySearchBox && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                        <TicketSearch />
                    </div>
                )}

                {/* {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <TicketSearch />
                    </div>
                } */}

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <TicketSearch />
                        </Sidebar>
                    </div>
                }
            </div>
        </div>

    )
}

export default TicketList
